import Vue from 'vue';
import { TaskType } from '#/protobuf/task_pb';
import { jobStatusDescription } from '#/models/jobs/job';
import { snapshotStatusDescription, STATUS_DESCRIPTION } from '#/models/jobs/snapshot';

const numeral = require('numeral');

Vue.filter('taskType', (taskType) => {
  switch (taskType) {
    case TaskType.TASK_COPY:
      return 'Copy';
    case TaskType.TASK_VERIFY:
      return 'Verify';
    case TaskType.TASK_UPLOAD:
      return 'Upload';
    case TaskType.TASK_DOWNLOAD:
      return 'Download';
    case TaskType.TASK_TRANSCODE:
      return 'Transcode';
    case TaskType.TASK_THUMBNAIL:
      return 'Thumb Generation';
    case TaskType.TASK_METADATA:
      return 'Media Analysis';
    case TaskType.TASK_COMPARE:
      return 'Compare';
    case TaskType.TASK_REPORT:
      return 'Report';
    case TaskType.TASK_INDEX:
      return 'Index';
    default:
      return 'Unknown Task';
  }
});

Vue.filter('jobType', (jobType) => {
  switch (jobType) {
    case 0:
      return 'Offload';
    case 1:
      return 'Archive';
    case 2:
      return 'Transcode';
    default:
      return 'Unknown';
  }
});

Vue.filter('jobStatusDescription', (job) => jobStatusDescription(job));
Vue.filter('snapshotStatusDescription', (snapshot) => snapshotStatusDescription(snapshot));

Vue.filter('badgeTypeForStatusDescription', (statusDescription) => {
  switch (statusDescription) {
    case STATUS_DESCRIPTION.WORKING:
      return 'success';
    case STATUS_DESCRIPTION.WAITING:
      return 'primary';
    case STATUS_DESCRIPTION.PAUSED:
      return 'primary'; // same as waiting since both are similar no-op states
    case STATUS_DESCRIPTION.DONE:
      return 'default';
    case STATUS_DESCRIPTION.CANCELED:
      return 'warning';
    case STATUS_DESCRIPTION.ERRORED:
      return 'danger';
    default:
      return 'warning';
  }
});

Vue.filter('bytes', (bytes, decimals, kb) => {
  const kib = kb || false;
  if (bytes === 0) return '0 Bytes';
  if (Number.isNaN(parseFloat(bytes)) && !Number.isFinite(bytes)) return 'Not an number';
  const k = kib ? 1024 : 1000;
  const dm = decimals || 2;
  const sizes = kib ? ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'] : ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  // eslint-disable-next-line no-restricted-properties
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
});

Vue.filter('badgeTypeForStanding', (jobStanding) => {
  switch (jobStanding) {
    case 0:
      return 'success'; // waiting
    case 1:
      return 'default'; // in progress
    case 2:
      return 'danger'; // errored
    case 3:
      return 'primary'; // verified
    case 4:
      return 'warning'; // canceled
    default:
      return ''; // unknown
  }
});

Vue.filter('jobStanding', (jobStanding) => {
  switch (jobStanding) {
    case 0:
      return 'No Status';
    case 1:
      return 'In Progress';
    case 2:
      return 'Errored';
    case 3:
      return 'Verified';
    case 4:
      return 'Canceled';
    default:
      return 'Unknown Status';
  }
});

Vue.filter('jobProgress', (jobProgress) => {
  switch (jobProgress) {
    case 0:
      return 'No Progress';
    case 1:
      return 'Not Yet Started';
    case 2:
      return 'Copying';
    case 3:
      return 'Verifying';
    case 4:
      return 'Reattempting Failed';
    case 5:
      return 'Completed';
    case 6:
      return 'Saving';
    case 7:
      return 'Pausing';
    case 8:
      return 'Paused';
    case 9:
      return 'Loading';
    case 10:
      return 'Generating Reports';
    case 11:
      return 'Sorting';
    default:
      return 'Unknown Progress';
  }
});

Vue.filter('currency_unit', (originalUnit) => originalUnit / 100);

Vue.filter('twoDigit', (originalInt) => numeral(originalInt).format('00'));
Vue.filter('capitalize', (value) => {
  if (!value) return '';
  // eslint-disable-next-line no-param-reassign
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});
